<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>I would like to dedicate my book to my wife, Carmel, sons, Oliver and Gerard, along with my dad, Paddy, Mam, Mary and all my family. Also, some special people in my life, Michael, Mary O’ Brien and family. My aunts, Jane, Rita, and uncles, Joe and Pat. Nieces, nephews, friends and also, an English teacher, called Mary Murphy for showing a kid another way.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?592d87fc